export const SET_BENCHMARK_DATA = 'benchmark/SET_BENCHMARK_DATA';

export const setBenchmarkData = (benchmarkData) => {
  return {
    type: SET_BENCHMARK_DATA,
    payload: benchmarkData,
  };
};
